import React, {useState, useEffect} from "react";

import {ReactComponent as FiatGroup} from '../../assets/img/Group 70.svg';
import '../../assets/styles/App.css';
import "@fontsource/montserrat";

import DisburseCollectChart from "../Charts/DisburseCollectChart.js";
import DisbursedCumulative from "../Charts/DisbursedCumulative.js";
import Heatmap from "../Charts/Heatmap.js";
import CashFlowChart from "../Charts/CashFlowChart.js";
import OpportunityPolar from "../Charts/OpportunityPolar.js";
import ReturnChart from "../Charts/ReturnChart.js";
import {Link} from "react-router-dom";

export default function CardInvestorDashboard(props) {
    const [hasApplications, setHasApplications] = useState(false);
    const [hasYieldTarget, setHasYieldTarget] = useState(false);
    const [hasCorTarget, setHasCorTarget] = useState(false);
    const [hasYieldYTD, setHasYieldYTD] = useState(false);
    const [hasCorYTD, setHasCorYTD] = useState(false);

    useEffect(() => {
        if (Object.keys(props.chartData).length > 0) {
            checkApplications();
            checkYield();
            checkCor();
        }
    }, [props.chartData]);

    const checkApplications = () => {
        if (props.chartData.qualified_applications > 0 && props.chartData.unqualified_applications > 0) {
            setHasApplications(true);
        } else {
            setHasApplications(false);
        }
    };

    const checkYield = () => {
        if (props.chartData.yield_target > 0) {
            setHasYieldTarget(true);
        } else {
            setHasYieldTarget(false);
        }

        if (props.chartData.ytd_yield > 0) {
            setHasYieldYTD(true);
        } else {
            setHasYieldYTD(false);
        }
    };

    const checkCor = () => {
        if (props.chartData.cor_target > 0) {
            setHasCorTarget(true);
        } else {
            setHasCorTarget(false);
        }

        if (props.chartData.ytd_collection_rate > 0) {
            setHasCorYTD(true);
        } else {
            setHasCorYTD(false);
        }
    };

    return (
        <>
            <div className="flex flex-wrap">
                <div className="relative md:w-8/12 lg:w-8/12 px-4 mb-3">
                    <div className="relative bg-white-2 w-full rounded-lg p-4 mb-3">

                    <div className="w-full flex items-center">
                        <div className="w-9/12">
                            <div className="relative flex flex-col text-white w-full">
                                <FiatGroup className="size-btc-group"/>
                                {/* <p className="text-12-700 text-center text-white mt-4">Rates</p> */}
                            </div>
                        </div>
                        <div className="w-9/12">
                            <div className="relative flex flex-col w-full px-6">
                                <h2 className="text-24-performance text-white">{props.chartData.partner} - {props.chartData.funder}</h2>
                                <p className="text-12-500 text-yellow mt-4">
                                    Investment in {props.chartData.country}
                                </p>
                            </div>
                        </div>
                    </div>

                    <p className="text-white text-14-400 py-6">Investment in {props.chartData.currency}
                        {props.chartData.has_opportunity && (
                        <span
                            className="text-right text-14-400 ">
                             <Link
                                 className="text-14-400 py-2 px-6 items-center text-blue bg-yellow rounded"
                                 to={"/opportunity"}
                                 state={[{
                                     "partner": props.chartData.partner,
                                     "funder": props.chartData.funder,
                                     "country": props.chartData.country,
                                     "currency": props.chartData.currency
                                 }]}
                             >
                                  Calculate Opportunity
                                </Link>
                        </span>
                        )}
                    </p>
                    <hr className="mb-4 bigHr"></hr>

                    <p className="pb-3 text-14-400 text-white">
                        YIELD TARGET <span className="text-right text-14-600">{hasYieldTarget ? (props.chartData.yield_target + '%') : ('NA')}</span>
                    </p>
                    <p className="pb-3 text-14-400 text-white">
                        COST OF RISK TARGET <span
                        className="text-right text-14-600">{hasCorTarget ? (props.chartData.cor_target + '%') : ('NA')}</span>
                    </p>
                    <p className="pb-3 text-14-400 text-yellow">
                        YTD YIELD <span
                        className="text-right text-14-600">{hasYieldYTD ? (Math.round((props.chartData.ytd_yield + Number.EPSILON) * 100) / 100 + '%') : ('NA')}</span>
                    </p>
                    <p className="pb-3 text-14-400 text-yellow">
                        YTD COST OF RISK <span
                        className="text-right text-14-600">{hasCorYTD ? (Math.round(((100 - props.chartData.ytd_collection_rate) + Number.EPSILON) * 100) / 100 + '%') : ('NA')}</span>
                    </p>

                        </div>

                </div>
                <div className="relative md:w-4/12 lg:w-4/12 px-4 mb-6">
                    <div className="relative bg-white-2 w-full h-full rounded-lg p-4">

                    <DisbursedCumulative
                            dataset={props.chartData.disbursement_cumulative.disbursed_to_date_local}
                            labels={props.chartData.disbursement_cumulative.labels}
                            title='Cumulative Disbursements'
                            subtitle="Disbursements"/>

                        </div>


                </div>
            </div>


            <div className="flex flex-wrap">

                <div className="relative md:w-6/12 lg:w-6/12 px-4 mb-3">
                    <div className="relative bg-white-2 w-full rounded-lg p-4 mb-3">

                        <DisburseCollectChart
                            dataset={props.chartData.disbursement.dataset}
                            collections={props.chartData.disbursement.collections}
                            labels={props.chartData.disbursement.labels}
                            title='Monthly Performance (Loans Due)'
                            subtitle="Disbursements"/>

                    </div>
                </div>

                <div className="relative md:w-6/12 lg:w-6/12 px-4 mb-3">
                    <div className="relative bg-white-2 w-full rounded-lg p-4 mb-3">

                        <ReturnChart
                            dataset={props.chartData.disbursement.risk_adjusted_return}
                            labels={props.chartData.disbursement.labels}
                            title='Risk Adjusted Returns (Revenue - Cost of Risk)'
                            subtitle="Risk Adjusted Returns"/>

                    </div>
                </div>

            </div>


            <div className="relative w-full px-4 mb-3">
                <div className="relative bg-white-2 w-full rounded-lg p-4 mb-3">

                    < Heatmap
                        yLabels={props.chartData.collections.yLabels}
                        xLabels={props.chartData.collections.xLabels}
                        data={props.chartData.collections.data}
                        title="Collection Rates"/>

                </div>
            </div>

            <div className="relative w-full px-4 mb-3">
                <div className="relative bg-white-2 w-full rounded-lg p-4 mb-3">

                    < Heatmap
                        yLabels={props.chartData.yield.yLabels}
                        xLabels={props.chartData.yield.xLabels}
                        data={props.chartData.yield.data}
                        title="Yield"/>

                </div>
            </div>

            {/*<div className="flex flex-wrap">*/}

            {/*    <div className="relative md:w-6/12 lg:w-6/12 px-4 mb-3">*/}
            {/*        <div className="relative bg-white-7 w-full rounded-lg p-4 mb-3">*/}

            {/*            {hasApplications ? (*/}
            {/*                <OpportunityPolar*/}
            {/*                    labels={['Qualified Applications', 'Unqualified Applications']}*/}
            {/*                    dataset={[props.chartData.qualified_applications, props.chartData.unqualified_applications]}*/}
            {/*                    title='Platform Applications (Last Month)'*/}
            {/*                />*/}
            {/*            ) : (*/}
            {/*                <CashFlowChart*/}
            {/*                    dataset={props.chartData.disbursement.netdata}*/}
            {/*                    labels={props.chartData.disbursement.labels}*/}
            {/*                    title='Net Cash Flow'*/}
            {/*                    subtitle="Net Cash Flow"/>*/}
            {/*            )}*/}



            {/*        </div>*/}
            {/*    </div>*/}

            {/*    <div className="relative md:w-6/12 lg:w-6/12 px-4 mb-3">*/}
            {/*        <div className="relative bg-white-7 w-full rounded-lg p-4 mb-3">*/}

            {/*            <CashFlowChart*/}
            {/*                dataset={props.chartData.disbursement.netdata}*/}
            {/*                labels={props.chartData.disbursement.labels}*/}
            {/*                title='Net Cash Flow'*/}
            {/*                subtitle="Net Cash Flow"/>*/}

            {/*        </div>*/}
            {/*    </div>*/}

            {/*</div>*/}


        </>
    );
}